import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalidadeGarantiaService } from "../modalidade-garantia.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-modal-percentuais-garantidos',
    templateUrl: './modal-percentuais-garantidos.component.html',
    styleUrls: ['./modal-percentuais-garantidos.component.scss'],
    standalone: false
})

//Modal para adicionar percertuais garantidos

export class ModalPercentuaisGarantidosComponent implements OnInit {
  public percentual: number;
  public formulario: FormGroup;
  public modalidadeService: ModalidadeGarantiaService;
  public mensagemAviso: string = "";

  constructor(public activeModal: NgbActiveModal, private formBuilder: FormBuilder) { 
    this.formulario = this.formBuilder.group({
      percentual: ['', [Validators.required, Validators.min(0)]]
    });
  }

  ngOnInit(): void {
  }

  public salvar() {
    if(this.percentual > 0 && this.percentual <= 100) {
      this.activeModal.close({botao: 'salvar', valor: this.percentual});
    }
    else if(this.percentual == null) {
      this.mensagemAviso = "Digite um valor para salvar."
    }
    else if(this.percentual == 0) {
      this.mensagemAviso = "O percentual não pode ser 0."
    }
    else if(this.percentual < 0) {
      this.mensagemAviso = "O percentual não pode ser menor que 0."
    }
    else if(this.percentual > 100) {
      this.mensagemAviso = "O percentual não pode ser maior que 100."
    }

    if (this.mensagemAviso) {
      setTimeout(() => {
        this.mensagemAviso = ""; 
      }, 5000);
    }
  }

  public cancelar() {
    this.activeModal.close({botao: 'cancelar', valor: null});
  }

  public fechar() {
    this.activeModal.close({botao: 'fechar', valor: null});
  }

}
